module.exports = __webpack_public_path__ + "static/media/picasso_samp.a98efd3b.png";